export class AuthRuntimeConstants {
    public static readonly tokenRefreshBufferMs = 60 * 1000;
    public static readonly forcedTokenRefreshIntervalMs = 60 * 1000;
}